const useValidation = (schema) => ({
  initialValues: schema.initialValues,
  validationSchema: schema.validation,
});

export default useValidation;
